export default "__VITE_ASSET__DIIz$jel__"